module.exports = "<div class=\"copyright\">© {{vendorTitle}} {{year}}. All Rights Reserved.</div>\n<div class=\"version\">Version {{version}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/footer/footer.component.html
// module id = ./src/app/home/pages/Dashboard/footer/footer.component.html
// module chunks = main